
import {
	UPDATE_CONFIGURATION,
	SET_RETURNING_PART_REASONS
} from './mutation-types'

export default {

	[UPDATE_CONFIGURATION] (state, config) {
		state.configuration = { ...state.configuration, ...config }
		// todo remove after some time
		localStorage.removeItem('app-configuration')
		localStorage.setItem('app-configuration-new', JSON.stringify(state.configuration))
	},

	[SET_RETURNING_PART_REASONS] (state, reasons) {
		state.returningPartReasons = reasons
	}
}
